webpackJsonp([32239989425883],{

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getTransitionStyle = __webpack_require__(30);
	
	var _getTransitionStyle2 = _interopRequireDefault(_getTransitionStyle);
	
	var _Footer = __webpack_require__(58);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Menu = __webpack_require__(52);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _IntlLink = __webpack_require__(23);
	
	var _IntlLink2 = _interopRequireDefault(_IntlLink);
	
	var _PageAnimations = __webpack_require__(59);
	
	var _PageAnimations2 = _interopRequireDefault(_PageAnimations);
	
	var _gatsbyImage = __webpack_require__(70);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbySourceDatocms = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$Component) {
	  _inherits(About, _React$Component);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    var _props$data$about = this.props.data.about,
	        title = _props$data$about.title,
	        mainContent = _props$data$about.mainContent,
	        teamTitle = _props$data$about.teamTitle,
	        teamContent = _props$data$about.teamContent,
	        teamImage = _props$data$about.teamImage,
	        officesTitle = _props$data$about.officesTitle,
	        officesContent = _props$data$about.officesContent,
	        officesImage = _props$data$about.officesImage;
	    var data = this.props.data;
	
	
	    var status = this.props.transition ? this.props.transition.status : "entering";
	    var menuStyle = (0, _getTransitionStyle2.default)(status, 200, 2000, 'menuStyle');
	    var timeout = 800;
	    var delay = 1000;
	
	    var sectionAppears = (0, _getTransitionStyle2.default)(status, timeout, 1000, 'pageAppearsFromBottom');
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: 'page',
	        style: { backgroundColor: data.page.themeColor.hex }
	      },
	      _react2.default.createElement(_gatsbySourceDatocms.HelmetDatoCms, {
	        seo: data.page.seo,
	        favicon: data.site.favicon
	      }),
	      _react2.default.createElement(_Menu2.default, {
	        style: menuStyle,
	        hasWhiteLogo: true,
	        data: this.props.data
	      }),
	      _react2.default.createElement(_PageAnimations2.default, {
	        status: status,
	        timeout: timeout,
	        delay: timeout,
	        color: data.page.themeColor.hex
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'page__wrapper' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'page__title--white', style: sectionAppears },
	          title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'page__textbox', style: sectionAppears },
	            _react2.default.createElement('div', {
	              style: sectionAppears,
	              className: 'page__text',
	              dangerouslySetInnerHTML: { __html: mainContent.markdown.html }
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page__section', style: sectionAppears },
	          _react2.default.createElement(
	            'div',
	            { className: 'page__textbox', style: sectionAppears },
	            _react2.default.createElement(
	              'div',
	              { className: 'page__image__container' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title--about', style: sectionAppears },
	                officesTitle
	              ),
	              _react2.default.createElement(_gatsbyImage2.default, {
	                sizes: officesImage.sizes,
	                title: teamImage.title,
	                alt: teamImage.alt
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement('div', {
	                style: sectionAppears,
	                className: 'page__text',
	                dangerouslySetInnerHTML: { __html: officesContent.markdown.html }
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'page__section page__section--last', style: sectionAppears },
	          _react2.default.createElement(
	            'div',
	            { className: 'page__textbox', style: sectionAppears },
	            _react2.default.createElement(
	              'div',
	              { className: 'page__image__container' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title--about', style: sectionAppears },
	                teamTitle
	              ),
	              _react2.default.createElement(_gatsbyImage2.default, { sizes: teamImage.sizes,
	                title: teamImage.title,
	                alt: teamImage.alt
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement('div', {
	                style: sectionAppears,
	                className: 'page__text',
	                dangerouslySetInnerHTML: { __html: teamContent.markdown.html }
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, { data: this.props.data })
	    );
	  };
	
	  return About;
	}(_react2.default.Component);
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-about-js-65da8b369cb8f97e3d0f.js